import { FC, ReactNode, createContext, useContext } from 'react';

const PreviewModeContext = createContext(false);

export const PreviewModeProvider: FC<{ children: ReactNode }> = ({ children }) => (
  <PreviewModeContext.Provider value={true}>{children}</PreviewModeContext.Provider>
);

export const usePreviewMode = (): boolean => useContext(PreviewModeContext);
